export type EntityKind = 'patient' | 'trial_site' | 'cro' | 'sponsor' | 'data';

export function resolveKindFromUserType(userType: string): EntityKind {
  switch (userType) {
    case 'medical_professional':
    case 'trial_site':
    case 'site_director':
    case 'principal_investigator':
    case 'clinical_research_coordinator':
      return 'trial_site';
    case 'sponsor_service_provider':
      return 'sponsor';
    case 'cro':
    case 'cro_manager':
    case 'cro_monitor':
      return 'cro';
    case 'datasets':
      return 'data';
    case 'patient_caregiver':
      return 'patient';
    default:
      return 'trial_site';
  }
}

export function mapProfileRoleToSOPRole(profileRole: string): string {
  switch (profileRole) {
    case 'sponsor_service_provider':
      return 'sponsor';
    case 'medical_professional':
    case 'healthcare_provider':
      return 'medical_professional';
    case 'trial_site':
      return 'trial_site';
    case 'site_director':
      return 'site_director';
    case 'principal_investigator':
      return 'principal_investigator';
    case 'clinical_research_coordinator':
      return 'clinical_research_coordinator';
    case 'patient_caregiver':
      return 'patient_caregiver';
    case 'cro':
    case 'cro_manager':
    case 'cro_monitor':
      return 'cro';
    case 'admin':
    case 'super_admin':
      return 'admin';
    default:
      return profileRole;
  }
}

// Check if user belongs to a CRO organization
export function isCROUser(organizationType: string | null | undefined): boolean {
  return organizationType === 'cro';
}
